import React, { useMemo, useEffect } from 'react';
import Preparations from './preparations/Preparations';
import PreparationsWithAlternative from './preparations/PreparationsWithAlternative';
import styles from './SidebarUnit.module.scss';
import { LessonType as TeacherLessonType,
  Content, LastVisitedLessonContentFragment } from '@api/graphql-codegen';
import { ExtendedUnit, ExtendedHeaUnit } from '@types';
import { useCourseContent } from '@hooks/useCourseContent';
import { isHomeEDApp } from '@constants';
import { sortByPosition } from '@utils/helpers';

interface SidebarUnitProps {
  unit: ExtendedUnit | ExtendedHeaUnit;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  isParentApp?: boolean;
  closeNav?: () => void;
}

const SidebarUnit = ({ unit, closeNav }: SidebarUnitProps) => {

  const { setCurrentUnit, setContent } = useCourseContent();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tpreps = useMemo(() => [...((isHomeEDApp ? (unit as ExtendedHeaUnit).parentPreparation || [] : (unit as ExtendedUnit)?.teacherPreparation) || [])].sort(sortByPosition), [(unit as ExtendedUnit)?.teacherPreparation]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const alternativePreps = useMemo(() => [...((unit as ExtendedUnit)?.alternateMaterials || [])].sort(sortByPosition), [(unit as ExtendedUnit)?.alternateMaterials]);
  const hasAlternative = useMemo(() => !!alternativePreps?.length, [alternativePreps?.length]);

  const listwrapper = useMemo(() => [styles.wrapper, styles.opened].join(' '), []);

  useEffect(() => {
    if (unit) {  
      setCurrentUnit(unit as any);
    }
  }, [unit, setCurrentUnit])

  useEffect(() => {
    if (tpreps.length > 0) {
      setContent(tpreps.at(0) as any)
    }
  }, [tpreps, setContent])
  
  return (
    <div className={listwrapper}>
      <section className={styles.list}>
        {hasAlternative ? (
          <PreparationsWithAlternative
            lessonOpened={true}
            lessonType={TeacherLessonType.PREPARATION}
            lesson={undefined}
            contents={tpreps as Content[]}
            alternativeContents={alternativePreps as Content[]}
            closeNav={closeNav}
          />
        ) : (
          <Preparations
            lessonOpened={true}
            lessonType={TeacherLessonType.PREPARATION}
            lesson={undefined}
            contents={tpreps as Content[]}
            closeNav={closeNav}
          />
        )}
      </section>
    </div>
  )
}

export default SidebarUnit;
